import { Observable } from 'rxjs/Observable';
import { NotificationService } from './../../services/NotificationService';
import { NotificationActionTypes } from './../action/index';
import { NotificationActions, ListNotificationsAction, RenewNotificationsAction, GetNotificationAction } from './../action/NotificationActions';
import { Actions, Effect } from '@ngrx/effects';
import { Injectable } from '@angular/core';

@Injectable()
export class NotificationEffects {
    
    constructor(
        private actions: Actions<NotificationActions>,
        private notificationService: NotificationService
    ) {

    }

    @Effect()
    list$ = this.actions.ofType(NotificationActionTypes.LIST)
        .map((action: ListNotificationsAction) => action)
        .switchMap(action => this.notificationService.listNotifications(action.payload.clientId, action.payload.userId)
            .map(response => ({ type: NotificationActionTypes.LIST_SUCCESS, data: response }))
            .catch(error => Observable.of({ type: NotificationActionTypes.LIST_ERROR, errorPayload: { errorStatus: error.status } }))
        );


    @Effect()
    get$ = this.actions.ofType(NotificationActionTypes.GET)
        .map((action: GetNotificationAction) => action)
        .switchMap(action => this.notificationService.getNotification(action.payload.clientId, action.payload.messageId)
            .map(response => ({ type: NotificationActionTypes.GET_SUCCESS, item: response }))
            .catch(error => Observable.of({ type: NotificationActionTypes.GET_ERROR, errorPayload: { errorStatus: error.status } }))
        );


    @Effect()
    renew$ = this.actions.ofType(NotificationActionTypes.RENEW)
        .map((action: RenewNotificationsAction) => action)
        .switchMap(action => this.notificationService.listNotifications(action.payload.clientId, action.payload.userId)
            .map(response => ({ type: NotificationActionTypes.RENEW_SUCCESS, data: response }))
            .catch(error => Observable.of({ type: NotificationActionTypes.RENEW_ERROR, errorPayload: { errorStatus: error.status } }))
        );

}


// WEBPACK FOOTER //
// ./src/store/effects/NotificationEffects.ts